import React, {Component} from "react";
import { observer } from "mobx-react";
import {comma} from "../../../../../utils/Utils";

@observer
class OrderMenuSideDetailCheckItemView extends Component {

    constructor(props){
        super(props);
        this.state = {sideSoldOut:false}
        this.fn_soldOutLayer = this.props.fn_soldOutLayer;
    }

    render() {
        const { rootStore , obj } = this.props;
        this.state.sideSoldOut = (obj.soldOut === "Y")?false:true;
        rootStore.menuStore.setSideMenuChecked({[obj.prodCd]:this.state.sideSoldOut});
        return(
            <li>
                <strong className="name">{obj.prodNm}</strong>
                <em className="pay">+ {comma(obj.saleUprc.toString())}원</em>
                <label className="lab_check">
                    <input type="checkbox" id={obj.prodCd} checked={this.state.sideSoldOut} onChange={this.fn_soldOutLayer}/>
                    <span></span>
                </label>
            </li>
        )
    }
}

export default OrderMenuSideDetailCheckItemView;